import type { ReactNode } from 'react'

import { faHourglassHalf } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'

import {
  ClientTimeZoneDateTime,
  DateTimeFormatType,
  FormattedMessage,
} from '@b-stock/fe-core/bstock-react'
import { Colors, pxToRem, Typography } from '@b-stock/fe-core/design-system'

const Footer = styled.footer`
  align-items: center;
  border-top: ${pxToRem(1)} solid ${Colors.Semantic.Neutral.medium_grey};
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.75rem 1rem 1rem;
  text-align: center;
`

const EndDateRow = styled.div`
  align-items: center;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
`

const HourglassIcon = styled(FontAwesomeIcon)`
  color: ${Colors.Semantic.Neutral.dark_grey};
  flex-shrink: 0;
  font-size: 0.875rem;
`

const EndDateContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  text-align: center;
`

const EndDateLine = styled.span`
  ${Typography.Body3_Semibold}
  color: ${Colors.Semantic.Neutral.very_dark_grey};
`

const EndDateLabel = styled.span`
  font-weight: 600;
`

const ReportProblemLink = styled.a`
  ${Typography.Caption}
  color: #9ca3af;
  cursor: pointer;
`

export const ActionCardFooter = ({
  endDate,
  endDateLabelId,
  endDateNote,
  onReportProblem,
  reportProblemLabelId,
}: {
  endDate?: Date | null
  endDateLabelId: string
  endDateNote?: ReactNode
  onReportProblem: () => void
  reportProblemLabelId: string
}) => (
  <Footer>
    {endDate && (
      <EndDateRow>
        <HourglassIcon icon={faHourglassHalf} />
        <EndDateContent>
          <EndDateLine>
            <EndDateLabel>
              <FormattedMessage id={endDateLabelId} />
            </EndDateLabel>{' '}
            <ClientTimeZoneDateTime
              dateTime={endDate}
              format={DateTimeFormatType.FULL}
            />
          </EndDateLine>
          {endDateNote}
        </EndDateContent>
      </EndDateRow>
    )}
    <ReportProblemLink
      href="https://bstock.com/contact-us/"
      target="_blank"
      rel="noreferrer"
      onClick={onReportProblem}
    >
      <FormattedMessage id={reportProblemLabelId} />
    </ReportProblemLink>
  </Footer>
)
